import getConfig from "next/config";

let config: any = {};
if (getConfig()) {
  const { publicRuntimeConfig, serverRuntimeConfig } = getConfig();
  config = {
    api_server: publicRuntimeConfig.API_SERVER || serverRuntimeConfig.API_SERVER,
    erp_server: publicRuntimeConfig.ERP_SERVER || serverRuntimeConfig.ERP_SERVER,
    messaging_server: publicRuntimeConfig.MESSAGING_SERVER || serverRuntimeConfig.MESSAGING_SERVER,
    calculation_server: publicRuntimeConfig.CALCAULATION_SERVER || serverRuntimeConfig.CALCAULATION_SERVER,
    google_place_service: publicRuntimeConfig.GOOGLE_PLACE_SERVICE || serverRuntimeConfig.GOOGLE_PLACE_SERVICE,
    enviroment: publicRuntimeConfig.ENVIROMENT || serverRuntimeConfig.API_SERVER,
    enviroment_Type:
      publicRuntimeConfig.enviroment_Type ||
      serverRuntimeConfig.enviroment_Type,
    user_app: publicRuntimeConfig.USER_APP_URL || serverRuntimeConfig.USER_APP_URL,
    hs_token: publicRuntimeConfig.HS_TOKEN || serverRuntimeConfig.HS_TOKEN,
    hs_service_name: publicRuntimeConfig.HS_SERVICE_NAME || serverRuntimeConfig.HS_SERVICE_NAME,
    hs_environment: publicRuntimeConfig.HS_ENVIRONMENT || serverRuntimeConfig.HS_ENVIRONMENT,
    MONDAY_API_TOKEN: publicRuntimeConfig.MONDAY_API_TOKEN || serverRuntimeConfig.MONDAY_API_TOKEN,
    MONDAY_BOARD_ID: publicRuntimeConfig.MONDAY_BOARD_ID || serverRuntimeConfig.MONDAY_BOARD_ID,
    TOPICS_GROUP_ID: publicRuntimeConfig.TOPICS_GROUP_ID || serverRuntimeConfig.TOPICS_GROUP_ID,
    go_support_widget_api_key:
      publicRuntimeConfig.GO_SUPPORT_WIDGET_API_KEY ||
      serverRuntimeConfig.GO_SUPPORT_WIDGET_API_KEY,
    go_support_widget_url:
      publicRuntimeConfig.GO_SUPPORT_WIDGET_URL ||
      serverRuntimeConfig.GO_SUPPORT_WIDGET_URL,
    recaptcha_site_key:
      publicRuntimeConfig.RECAPTCHA_SITE_KEY ||
      serverRuntimeConfig.RECAPTCHA_SITE_KEY,
    shared_login_domains:
      publicRuntimeConfig.SHARED_LOGIN_DOMAINS ||
      serverRuntimeConfig.SHARED_LOGIN_DOMAINS,
    legacy_login_domains:
      publicRuntimeConfig.LEGACY_LOGIN_DOMAINS ||
      serverRuntimeConfig.LEGACY_LOGIN_DOMAINS,
    hp_tenant_id:
      publicRuntimeConfig.HP_TENANT_ID ||
      serverRuntimeConfig.HP_TENANT_ID,
    hp_theme:
      publicRuntimeConfig.HP_THEME ||
      serverRuntimeConfig.HP_THEME,
  };
}

export default config;
